(function () {
  document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', function (event) {
    const categories = document.querySelectorAll('.cpb-category-fontFamily');
    const store = CPB.getStore();

    categories.forEach(category => {
      const categoryId = category.dataset.categoryId;

      category.addEventListener('click', (e) => {
        const layers = store.getState().Product.layers;
        const isLayerExist = layers.find(layer => layer.category === categoryId);

        if (
          isLayerExist &&
          e.target.localName === 'span' &&
          e.target.innerText === isLayerExist.value
        ) {
          e.stopPropagation();
        }
      });
    });
  });
})();
/* Taeradesign: Schriftvorschau im CPB-Schrift-Dropdown (Stand 14.10.2026)
   - zeigt jeden Eintrag und die gewählte Schrift in der eigenen Schrift
   - lesbarer Name statt Dateiname (nur Anzeige; CPB arbeitet weiter mit dem Dateinamen)
   - Schriftdateien kommen aus CPB (Global.fonts), keine eigenen Kopien
   NUR_PRODUKTE: leer = alle CPB-Produkte, sonst nur diese Shopify-Produkt-IDs
   Liegt im Theme in assets/customproductbuilder.js (an den bestehenden Code angehängt). */
(function () {
  var NUR_PRODUKTE = [];
  var NAMEN = {
    "!PaulMaul.ttf": "Paul Maul", "ARLRDBD.TTF": "Arial Rounded", "CASWD_.TTF": "Caswallon",
    "COMIC.TTF": "Comic Sans", "Courgette_Regular.ttf": "Courgette", "FRAMD.TTF": "Franklin Gothic",
    "ITCKRIST.TTF": "Kristen ITC", "IndieFlower-Regular.ttf": "Indie Flower", "MTCORSVA.TTF": "Monotype Corsiva",
    "PatrickHand-Regular.ttf": "Patrick Hand", "SAGINAWBOLD.TTF": "Saginaw Bold",
    "ScriptMTBoldTaeradesign-Regular.ttf": "Script MT Bold", "akaDora.ttf": "Aka Dora", "playball.regular.ttf": "Playball"
  };
  // Größenausgleich, damit kleine Schriften im Dropdown gleich groß wirken
  var GROESSE = { "!PaulMaul.ttf": 1.45, "IndieFlower-Regular.ttf": 1.2, "CASWD_.TTF": 1.12,
    "MTCORSVA.TTF": 1.12, "SAGINAWBOLD.TTF": 1.08, "akaDora.ttf": 1.08, "ITCKRIST.TTF": 0.94 };
  function produktId() {
    try { return Number(window.ShopifyAnalytics.meta.product.id); } catch (e) { return null; }
  }
  if (NUR_PRODUKTE.length && NUR_PRODUKTE.indexOf(produktId()) < 0) return;

  var css = ".cpb-font-pv{font-size:0!important;letter-spacing:0!important}" +
    ".cpb-font-pv::after{content:attr(data-cpb-label);font-size:calc(18px * var(--cpb-pv,1));line-height:1.35}" +
    ".cpb-category-fontFamily [class*='singleValue'].cpb-font-pv::after{font-size:calc(17px * var(--cpb-pv,1))}";
  var st = document.createElement("style");
  st.textContent = css;
  document.head.appendChild(st);

  var geladen = {};
  function familie(n) { return "cpbpv_" + n.replace(/[^A-Za-z0-9]/g, "_"); }
  function datei(n) {
    try {
      var f = CPB.getStore().getState().Global.fonts || [];
      for (var i = 0; i < f.length; i++) if (f[i].name === n) return f[i].file;
    } catch (e) {}
    return null;
  }
  function laden(n) {
    if (geladen[n]) return geladen[n];
    var url = datei(n);
    if (!url || !window.FontFace) return null;
    geladen[n] = new FontFace(familie(n), 'url("' + url + '")').load()
      .then(function (f) { document.fonts.add(f); return true; })
      .catch(function () { return false; });
    return geladen[n];
  }
  function anzeige(n) {
    return NAMEN[n] || n.replace(/\.(ttf|otf)$/i, "").replace(/^!/, "").replace(/[_.-]+/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2").replace(/\s+Regular$/i, "").trim();
  }
  function schmuecken(el, n) {
    if (el.getAttribute("data-cpb-font") === n) return;
    el.setAttribute("data-cpb-font", n);
    el.setAttribute("data-cpb-label", anzeige(n));
    el.classList.add("cpb-font-pv");
    el.style.setProperty("--cpb-pv", String(GROESSE[n] || 1));
    var p = laden(n);
    if (p) p.then(function (ok) { if (ok && el.getAttribute("data-cpb-font") === n) el.style.fontFamily = '"' + familie(n) + '", sans-serif'; });
  }
  function scan() {
    var a = document.querySelectorAll(".cpb-font-preview-loader > span, .cpb-category-fontFamily [class*='singleValue']");
    for (var i = 0; i < a.length; i++) {
      var n = (a[i].textContent || "").trim();
      if (n) schmuecken(a[i], n);
    }
  }
  var geplant = false;
  new MutationObserver(function () {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(function () { geplant = false; scan(); });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  scan();
})();

/* Taeradesign: Firefox-Hinweis in der Beschreibung „Schriftart“ ausblenden (14.10.2026).
   Die Schriftvorschau (cpb_schriftvorschau.js) nutzt die Standard-Schrift-API und braucht den Hinweis nicht mehr.
   Entfernt im Absatz mit „Firefox“ alles ab dem Zeilenumbruch vor <strong>HINWEIS:</strong>. Text in CPB bleibt unverändert. */
(function () {
  function weg() {
    var s = document.querySelectorAll("[class*='cpb-category'] strong");
    for (var i = 0; i < s.length; i++) {
      var st = s[i], p = st.parentNode;
      if (!p || !/^\s*HINWEIS:?\s*$/i.test(st.textContent) || !/Firefox/i.test(p.textContent)) continue;
      var start = st;
      while (start.previousSibling && start.previousSibling.nodeType === 3 && !start.previousSibling.textContent.trim()) start = start.previousSibling;
      if (start.previousSibling && start.previousSibling.nodeName === "BR") start = start.previousSibling;
      while (start) { var nx = start.nextSibling; p.removeChild(start); start = nx; }
    }
  }
  var geplant = false;
  new MutationObserver(function () {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(function () { geplant = false; weg(); });
  }).observe(document.body, { childList: true, subtree: true });
  weg();
})();

/* CPB-Vorschau: Seitenverhältnis der Bühne als --cpb-ar an #product-builder (für die Höhenbegrenzung in customproductbuilder.css). 14.10.2026 */
(function(){function u(){var p=document.getElementById('product-builder');var K=window.Konva;if(!p||!K||!K.stages||!K.stages.length)return;var s=K.stages[0],w=s.width(),h=s.height();if(w>0&&h>0){var a=h/w,o=parseFloat(p.style.getPropertyValue('--cpb-ar'))||0;if(Math.abs(a-o)>0.01){p.style.setProperty('--cpb-ar',a.toFixed(3));window.dispatchEvent(new Event('resize'));}}}setInterval(u,800);})();
